import React from 'react';
import classNames from 'classnames';
import Icon from '../icon';

function ElementDragLayer({
  text,
  glyph = 'move',
  glyphSize = 16,
  glyphStrokeWidth = 2,
  className = '',
  ...otherProps
}) {
  const classes = classNames('ws-element-drag-layer', className);

  return (
    <div {...otherProps} className={classes}>
      <Icon glyph={glyph} size={glyphSize} strokeWidth={glyphStrokeWidth} />
      <span className="ws-element-drag-layer__label">{text}</span>
    </div>
  );
}

export default ElementDragLayer;
